module.exports = __webpack_public_path__ + "img/dock-barrier.7363787e.svg";